<template>
  <v-data-table
    :items-per-page="50"
    :headers="headers.filter(h => h.show === undefined || h.show())"
    :items="items"
    :items-length="items.length"
    :loading="loading"
    density="comfortable"
    :hide-default-footer="true"
    hover
    multi-sort
    color="primary"
  >
    <template #[`item.price`]="{ item: row }">
      {{ currency(row.price) }}
    </template>
    <template #[`item.gross_revenue`]="{ item: row }">
      {{ currency(row.revenue) }}
    </template>
    <template #[`item.revenue`]="{ item: row }">
      {{ currency(row.revenue - row.discounts) }}
    </template>
    <template #[`item.discounts`]="{ item: row }">
      {{ currency(row.discounts) }}
    </template>
    <template #[`item.fees`]="{ item: row }">
      {{ currency(row.fees) }}
    </template>
    <template #body.append>
      <tr>
        <td class="font-weight-bold">
          Total
        </td>
        <td />
        <td />
        <td class="text-center font-weight-bold">
          {{ items.reduce((acc, i) => acc + i.count, 0) }}
        </td>
        <td class="text-center font-weight-bold">
          {{
            currency(
              items.reduce((acc, i) => acc + i.revenue, 0)
            )
          }}
        </td>
      </tr>
    </template>
    <template #bottom />
  </v-data-table>
</template>

<script lang="ts" setup>
import { currency } from '@/helpers/formatters/currency'
import { DataTableHeader } from '@/types/DataTable'
import RevenueRecord from '@/types/RevenueRecord'
import { Ref, ref } from 'vue'

const headers: Ref<DataTableHeader[]> = ref([
  { title: 'Setor', value: 'sector', key: 'sector', sortable: true },
  { title: 'Tipo', value: 'type', key: 'type', sortable: true },
  { title: 'Lote', value: 'batch', key: 'batch', sortable: true, align: 'center' },
  { title: 'Vendidos', value: 'count', key: 'count', sortable: false, align: 'center' },
  { title: 'Valor Unitário', value: 'price', key: 'price', sortable: false, align: 'center' },
])

interface Props {
  items: RevenueRecord[]
  loading: boolean
}

const { items, loading } = defineProps<Props>()
</script>
